import React from 'react';
import ConnectedAddReview from './ConnectedAddReview';

// used for the /account/add-review route, identical to default except for the isModal prop
export const modalReview = (context: any) => {
  const queryParamFlowType = context.query && context.query.fs;
  const bookingId = context.params && context.params.bookingId;

  return {
    chunks: ['addReview'],

    component: (
      <ConnectedAddReview bookingId={bookingId} isModal queryParamFlowType={queryParamFlowType} />
    ),
    accountWrapper: {
      loginRequired: false,
    },
  };
};

export default (context: any) => {
  const queryParamFlowType = context.query && context.query.fs;
  const bookingId = context.params && context.params.id;

  return {
    chunks: ['addReview'],

    component: <ConnectedAddReview bookingId={bookingId} queryParamFlowType={queryParamFlowType} />,
    accountWrapper: {
      loginRequired: false,
    },
  };
};

if (module.hot) {
  module.hot.accept();
}
